import EmailHubComponent from '../Components/Email/EmailHubComponent';

function EmailHubPage() {
  return <EmailHubComponent />;
}

export default EmailHubPage;
